import type { SVGProps } from 'react'

const DarkMode = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9128 11.9523C10.7189 11.8823 8.11777 9.28115 8.04777 6.08726C8.04221 5.82226 8.05333 5.56115 8.0811 5.30504C8.13221 4.83226 7.60944 4.51615 7.2161 4.78282C5.68888 5.81893 4.68555 7.56893 4.68555 9.55337C4.68555 12.7323 7.26832 15.315 10.4467 15.3145C12.4311 15.3145 14.1811 14.3112 15.2172 12.7839C15.4844 12.3906 15.1678 11.8684 14.695 11.9189C14.4389 11.9467 14.1778 11.9578 13.9128 11.9523Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default DarkMode
